<template>
  <div class="header-container">
    <div class="l-content">
      <el-button
        @click="handleMenu"
        icon="el-icon-menu"
        size="mini"
        style="margin-right: 20px"
      ></el-button>
      <el-breadcrumb separator="|">
        <el-breadcrumb-item
          v-for="item in tags"
          :key="item.path"
          :to="{ path: item.path }"
          >{{ item.label }}</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <div class="r-content">
      <el-dropdown>
        <div class="user">
          <span class="el-icon-user"></span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="handleLogout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Cookie from 'js-cookie'
export default {
  data() {
    return {};
  },
  methods: {
    handleMenu() {
      this.$store.commit("collapseMenu");
    },
    handleLogout(){
      Cookie.remove('token')
      Cookie.remove('menu')
      this.$store.commit("deleteMenu");
      this.$router.replace('/login')
    }
  },
  computed: {
    ...mapState({
      tags: (state) => state.tab.tabsList,      
    }), 
  },
};
</script>

<style lang="less" scoped>
.header-container {
  background-color: #333;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  .text {
    color: #fff;
    font-size: 14px;
    margin-left: 20px;
  }
  .r-content {
    .user {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #fff;
      font-size: 20px;
      line-height: 40px;
      text-align: center;
      margin-right: 40px;
    }
  }
  .l-content {
    display: flex;
    align-items: center;
    .el-breadcrumb ::v-deep .el-breadcrumb__inner {
      color: #fff !important;
      font-weight: 400 !important;
      overflow: hidden;
    }
  }
}
</style>